module.exports = __webpack_public_path__ + "static/media/wifi-2.ef23cc63.svg";